/* 🤖 this file was generated by svg-to-ts */
export const nsDelete: {
  name: 'delete';
  data: string;
} = {
  name: 'delete',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"><path fill-rule="evenodd" d="M8.768 2h5.364c.754 0 1.368.557 1.368 1.241V4.7H20v1.41h-1.602l-1.25 13.247c-.034.364-.361.643-.753.643H5.58c-.392 0-.72-.28-.753-.643L3.577 6.11H2V4.7h5.4V3.241C7.4 2.557 8.014 2 8.768 2Zm.274 2.7h4.816V3.49H9.042V4.7Zm-2.77 13.89h9.43L16.88 6.11H5.095l1.177 12.48ZM8.88 8.3l.32 8.05-1.478.05L7.4 8.35l1.48-.05Zm4.242 0 1.479.05-.32 8.05-1.48-.05.32-8.05Z" clip-rule="evenodd"/></svg>`
};
